import { useState } from 'react'
import { SegmentedControl } from '@teach/ui'
import { AdminCoursesTable } from './AdminCoursesTable'
import { AdminInstructionsTable } from './AdminInstructionsTable'
import { useMessages } from '@/i18n'
import { messages } from './messages'

type Tab = 'instructions' | 'courses'

export const AdminPage = () => {
  const [tab, setTab] = useState<Tab>('instructions')
  const m = useMessages(messages)
  return (
    <div className="container mx-auto px-6 py-8 max-w-7xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">{m.moderation}</h1>
        <p className="text-sm text-muted-foreground mt-1">{m.moderationHint}</p>
      </div>
      <SegmentedControl<Tab>
        className="mb-4"
        value={tab}
        onChange={setTab}
        options={[
          { id: 'instructions', label: m.tabArticles },
          { id: 'courses', label: m.tabCourses },
        ]}
      />
      {tab === 'instructions' ? <AdminInstructionsTable /> : <AdminCoursesTable />}
    </div>
  )
}
